/* istanbul ignore file -- entire file is v3-only, not part of the v4 API */
import { stripLoginId } from '../utils';

// ─── v3-only — Not available on v4 OTP connections ────────────────────────────
// All WebSocket messages in this file are part of the Deriv v3 API only.
// They are not listed in the v4 API docs (https://developers.deriv.com/llms.txt).
// On a rawApiUrl (OTP-authenticated v4) connection these calls will fail.
// Only use them with legacyMode connections or v3-compatible endpoints.

/**
 * @deprecated v3 only. API tokens are managed via the Deriv dashboard or
 * v3 WebSocket `api_token` call. Not available in the v4 API.
 */
export const deleteApiToken = (token) => ({
    api_token: 1,
    delete_token: token,
});

/**
 * @deprecated v3 only. Not available in the v4 API.
 */
export const getApiTokens = () => ({
    api_token: 1,
});

/**
 * @deprecated v3 only. Not available in the v4 API.
 */
export const createApiToken = (token, scopes) => ({
    api_token: 1,
    new_token: token,
    new_token_scopes: scopes,
});

/**
 * @deprecated v3 only. Not available in the v4 API.
 */
export const changePassword = (oldPassword, newPassword) => ({
    change_password: 1,
    old_password: oldPassword,
    new_password: newPassword,
});

/**
 * @deprecated v3 only. Not available in the v4 API.
 */
export const registerApplication = (options) => ({
    app_register: 1,
    ...stripLoginId(options),
});

/**
 * @deprecated v3 only. Not available in the v4 API.
 */
export const getAllAppList = () => ({
    app_list: 1,
});

/**
 * @deprecated v3 only. Not available in the v4 API.
 */
export const getAppslistById = (appid) => ({
    app_get: appid,
});

/**
 * @deprecated v3 only. Not available in the v4 API.
 */
export const deleteApplication = (appid) => ({
    app_delete: appid,
});

/**
 * @deprecated v3 only. Use `DerivREST.createAccount(bearer, appId, 'real', currency, group)`
 * via `POST /trading/v1/options/accounts` in the v4 API.
 */
export const createRealAccountMaltaInvest = (options) => ({
    new_account_maltainvest: 1,
    ...stripLoginId(options),
});

/**
 * @deprecated v3 only. Use `DerivREST.createAccount(bearer, appId, 'real', currency, group)`
 * via `POST /trading/v1/options/accounts` in the v4 API.
 */
export const createRealAccount = (options) => ({
    new_account_real: 1,
    ...stripLoginId(options),
});

/**
 * @deprecated v3 only. Not available in the v4 API.
 */
export const setAccountCurrency = (currency) => ({
    set_account_currency: currency,
});

/**
 * @deprecated v3 only. Not available in the v4 API.
 */
export const setSelfExclusion = (options) => ({
    set_self_exclusion: 1,
    ...stripLoginId(options),
});

/**
 * @deprecated v3 only. Not available in the v4 API.
 */
export const setAccountSettings = (options) => ({
    set_settings: 1,
    ...stripLoginId(options),
});

/**
 * @deprecated v3 only. Not available in the v4 API.
 */
export const setTnCApproval = () => ({
    tnc_approval: 1,
});
